import { useState } from 'react'

import { TextareaWithSubmit } from '@/components/composer/TextareaWithSubmit'
import { Button } from '@/components/ui/button'
import { useSendSalesLeadSms } from '@/models/salesLead'

const SMS_SEGMENT_LEN = 160

interface SmsReplyFormProps {
  leadId: string
  inReplyToActivityId: string
  to: string | null
  onSent: () => void
  onCancel: () => void
}

export function SmsReplyForm({ leadId, inReplyToActivityId, to, onSent, onCancel }: SmsReplyFormProps) {
  const [body, setBody] = useState('')
  const sendMutation = useSendSalesLeadSms()
  const segments = body.length === 0 ? 0 : Math.ceil(body.length / SMS_SEGMENT_LEN)

  function handleSubmit(message: string) {
    sendMutation.mutate(
      { id: leadId, content: message, to: to ?? undefined, inReplyToActivityId },
      {
        onSuccess: () => {
          setBody('')
          onSent()
        },
      }
    )
  }

  const errorMessage = sendMutation.isError
    ? ((sendMutation.error as { response?: { data?: { error?: string } } }).response?.data?.error ??
      'Send failed')
    : null

  return (
    <div className="flex flex-col gap-2">
      {to && (
        <div className="text-muted-foreground text-sm">
          Replying by SMS to <span className="font-medium">{to}</span>
        </div>
      )}
      <TextareaWithSubmit
        value={body}
        onValueChange={setBody}
        placeholder="Write your reply…"
        onSubmitMessage={({ message }) => handleSubmit(message)}
        buttonProps={{ disabled: sendMutation.isPending }}
        addonChildren={
          <Button variant="ghost" size="sm" onClick={onCancel}>
            Cancel
          </Button>
        }
        leadingHint={
          <>
            {body.length} chars
            {segments > 0 && (
              <>
                {' · '}
                {segments} segment{segments === 1 ? '' : 's'}
              </>
            )}
          </>
        }
      />
      {errorMessage && <p className="mt-1 text-xs text-red-600">{errorMessage}</p>}
    </div>
  )
}
